import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpHandler, HttpBackend } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  endpoint: string = environment.restUrl;
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  retry = 0;

  private httpWithoutInterceptor: HttpClient;

  constructor(
    private handler: HttpBackend,
    private http: HttpClient,
  ) {
    this.httpWithoutInterceptor = new HttpClient(this.handler);
  }

  getFaq() {
    let api = `${this.endpoint}/faq`;
    return this.http
      .get(api, { headers: this.headers, responseType: 'json' })
      .pipe(retry(this.retry), catchError(this.handleError));
  }

  getAdditionalServices() {
    let api = `${this.endpoint}/v1/hub/additional-services`;
    return this.http
      .get(api, { headers: this.headers, responseType: 'json' })
      .pipe(retry(this.retry), catchError(this.handleError));
  }

  getSolutionAndEvents() {
    let api = `${this.endpoint}/v1/hub/solutions-and-events`;
    return this.http
      .get(api, { headers: this.headers, responseType: 'json' })
      .pipe(retry(this.retry), catchError(this.handleError));
  }

  handleError(error: HttpErrorResponse) {
    let msg = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }
}
